import { render, staticRenderFns } from "./warehouse-history-combiner.vue?vue&type=template&id=b10736b6&scoped=true"
import script from "./warehouse-history-combiner.vue?vue&type=script&lang=js"
export * from "./warehouse-history-combiner.vue?vue&type=script&lang=js"
import style0 from "./warehouse-history-combiner.vue?vue&type=style&index=0&id=b10736b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10736b6",
  null
  
)

export default component.exports